// extracted by mini-css-extract-plugin
export var icon = "BackButton-module--icon--1d3dc";
export var iconDesktop = "BackButton-module--icon--desktop--8bfc7";
export var root = "BackButton-module--root--4e8d3";